<template>
<div>
  <div class="xsmall-hide small-hide bg-1">
  </div>
  <div class="medium-hide large-hide xlarge-hide">
    <img src="../assets/naniungo-slide-19.jpg">
  </div>
  <div class="md-layout mt-40 ">
  <div class="md-layout mt-100 title">
  </div>
     <div class="md-layout-item mt-40 md-xlarge-size-20 md-large-size-20 md-medium-size-20 md-small-hide md-xsmall-hide">
      </div>
      <div class="md-layout-item md-xlarge-size-60 md-large-size-60 md-medium-size-60 md-small-size-100 md-xsmall-size-100 title">
        <h1>Unsere Themenschwerpunkte</h1>
      </div>
      <div class="md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-20 md-small-hide md-xsmall-hide">
      </div>
  </div>
  <div style="margin-left:10vw; margin-right:10vw;">
      <div v-for="columns in columnsThemen" :key="columns.name" class="md-layout-item m-25 md-xsmall-size-100 cell">
          <h1>
              {{columns.name}}
          </h1>
          <p>
              {{ columns.subtitle }}
          </p>
          <md-button @click="columns.toggle()" class="md-accent"><md-icon>{{ columns.show ? 'remove' : 'add' }}</md-icon>
          <span>mehr</span>
        </md-button>
        <div class="md-layout-item" v-show-slide:exampleEasing="columns.show">
          <p v-for="items in columns.ps" :key="items">{{ items.p }} </p>
        </div>
      </div>
  </div>

<div class="message dark secondary mt-40">
  <router-link style="width:100%;" v-bind:to="'karriere'">
  <h1>Karrieremöglichkeiten<md-icon class="green ml-20">arrow_forward</md-icon></h1>
  </router-link>
</div>

</div>

</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Themen',
  data() {
    return {
      firstName: "",
      lastName: "",
      jobTitle: "",
      emailAddressPrivate: "",
      phoneNumberBusiness: "",
      hobbies: "",
      ambition: "",
      level: "",
      function: "",
      carerix_id: "",
      functionOne:"",
      method:"",
      columnsThemen: [
        {
          name: "Accounting",
          subtitle: "naniungo unterstützt Sie mit Experten bei Ihren Projekten und Herausforderungen im Accounting, um schnell und flexibel auf Marktveränderungen zu reagieren. Wir verbinden Sie mit genau dem richtigen Experten für unterschiedliche Fragestellungen.",
          show: false,
          icon: "accounting.svg",
          toggle() {
              this.show = !this.show
            },
          ps:[
            {
              p:"Unser Netzwerk erstreckt sich von Experten im Bereich klassischer Buchhaltungsthemen wie der Unterstützung im Jahresabschluss nach verschiedenen Rechnungslegungsstandards, dem Führen der Haupt- und Nebenbücher und der Unterstützung im Tagesgeschäft, sowie Spezialthemen, bei denen es unter anderem um elektronische Rechnungsworkflows, Aufbau von financial Shared Service Centern oder Prozessthemen im P2P oder R2R Umfeld geht. Zudem unterstützen unsere Experten auch bei Schnittstellen Themen in ERP Systemen, wenn es um Werteflüsse oder beispielsweise die Einführung von S4/Hana geht."
            }
          ]
        },
        {
          name: "Controlling",
          subtitle: "Leicht verständliche Analysen, aussagefähige Kennzahlen und klare Handlungsempfehlungen nehmen wir und unsere Experten gerne für Sie in die Hand, damit Sie sich Ihrem Kerngeschäft widmen können.",
          show: false,
          icon: "controlling.svg",
          toggle() {
              this.show = !this.show
            },
          ps:[
            {
              p:"Wir begleiten unsere Kunden bei der Optimierung von Controllingprozessen, sowie bei der Implementierung von operativen und strategischen Controlling-Instrumenten (Kosten- und Leistungsrechnung, Budgetierung, Produktkalkulation, Marktsegmentrechnung, Vertriebscontrolling, Produktionscontrolling, Beteiligungscontrolling, Personalcontrolling, Profit Center-Rechnung, Portfolioanalyse, SWOT-Analyse, Reportingstrukturen und Werteflüssen etc.). Der digitale Wandel im Bereich RPA (robotic process automation) im Controlling ist ebenfalls ein häufiger Ansatzpunkt, bei dem wir unsere Kunden unterstützen."
            },
            {
              p:"Werfen Sie einen Blick auf unsere Experten im Bereich „projects“ und „executives“ oder kontaktieren Sie uns gerne für mehr Informationen."
            }
          ]
        },
        {
          name: "Finance Functions",
          subtitle: "In der Kategorie Finance Functions eröffnen wir Ihnen ein Netzwerk an Experten aus dem Bereich Corporate Finance, Treasury, Tax, Audit, Merger & Acquisitions und Risk Management. ",
          show: false,
          icon: "steuern.svg",
          toggle() {
              this.show = !this.show
            },
          ps:[
            {
              p:"Bewertungs- und Grundsatzthemen, steuerliche Bewertung und internationales Steuerrecht, Konsolidierungsaufgaben oder Transferpreisberechnung- und Dokumentation sind Themengebiete, welche wir mit unseren Experten abdecken. Hinzu kommen Tätigkeiten bei der Auswahl und Implementierung von internen Kontrollsystemen, Valuation & Modelling, der Planung und Durchführung von Audits & Compliance, sowie SOX Implementierungen."
            },
            {
              p:"Werfen Sie einen Blick auf unsere Experten im Bereich „projects“ und „executives“ oder kontaktieren Sie uns für mehr Informationen."
            }
          ]
        },
        {
          name: "Marketing",
          subtitle: "Die Zeiten des Gebrauchs traditioneller Kanäle im Bereich der Medien gehört mittlerweile der Vergangenheit an und die Unternehmen, die sich optimal auf diesen Wechsel anpassen und mit modernen Marketingaktivitäten ihre Adressaten zielgerichtet erreichen, werden bekannter und erfolgreicher! Wir helfen Ihnen dabei.",
          show: false,
          icon: "marketing.svg",
          toggle() {
              this.show = !this.show
            },
          ps:[
            {
              p:"Beim modernen Marketing liegt der Fokus auf den Bedürfnissen und Werten der Unternehmen, vereint mit der Digitalisierung. Wir bieten Ihnen die Möglichkeit, sich mit ganz neuen und modernen Möglichkeiten aufzustellen. Wir verbinden Sie mit einflussreichen Influencern, Bloggern oder Journalisten um die Themen, auf die es Ihnen ankommt, gezielt zu vermarkten. Neben Influencer Marketing zählt ebenfalls die Entwicklung und Umsetzung einer eigenen Marketingstrategie, die Auswahl der Marketinginstrumente sowie die Markenentwicklung und Corporate Identity zu einem erfolgreichen Konzept. Die neuen Werkzeuge im Bereich E-Commerce, Online-Marketing, Suchmaschinen-Marketing, Social-Media und Big Data sind viel komplexer geworden, aber wir und unsere Experten helfen Ihnen sich gezielt und erfolgreich zu positionieren."
            }
          ]
        },
        {
          name: "Sonderprojekte",
          subtitle: "Sie stehen vor großen Veränderungen in Ihrer Organisation? Der Bereich der Sonderprojekte umfasst alle Spezialthemen, bei denen Sie ein ganz bestimmtes Know-how außerhalb der klassischen Finanzbereiche benötigen.",
          show: false,
          icon: "steuern.svg",
          toggle() {
              this.show = !this.show
            },
          ps:[
            {
              p:"Im Bereich der Sonderprojekte greifen wir auf einen ausgewählten Experten Pool mit jahrelanger Branchenerfahrung zu, der Sie in außergewöhnlichen Unternehmenssituationen schnell und effizient unterstützt. Kerngebiete sind hier Projekte im Bereich Business Transformation, Procurement, Facility Management, Supply Chain Management, HR und IT. Unsere Interim Manager sind Profis auf Ihrem Gebiet und können ohne lange Einarbeitung Lösungen erarbeiten und Effizienz schaffen. Zudem sind sie erfahrene Führungskräfte und auch im Projektmanagement oder als Projektleiter bei ERP-Implementierungen, sowie im Prozessmanagement ein echter Mehrwert."
            },
            {
              p:"Sprechen Sie uns jederzeit an!"
            }
          ]
        }
      ],
      varCandidates: [{
          "ambition" : '',
          "isOpen"  : false,
          "addtoCart": false,
          "carerix_id": ''
      }]
    }
  },
  computed: {
    ...mapState({
      candidates: state =>
      state.candidates.candidates,
      cart: state =>
      state.cart.cart
    })
  },
  created() {
  // this.$store.dispatch('candidates/getCandidates');
  },
  methods: {
    ...mapActions ('candidates', 'cart', [
        'addCandidate',
        'deleteCandidate',
        'updateCandidate',
        'getCart'
    ]),
    toggleOpen(value) {
        var item = this.varCandidates.filter(obj => {
        return obj.ambition === value
        })[0]

        if (typeof item !== "undefined") {
        item.isOpen = !item.isOpen
        }
    },
    getToggleState(value) {
        const item = this.varCandidates.filter(obj => {
        return obj.ambition === value
        })[0]
        if (typeof item !== "undefined") {
          return item.isOpen
        }
    },
    toggleCart(value) {
      // const item = this.$store.state.cart.cart.filter(obj => {
      const item = this.varCandidates.filter(obj => {      
      return obj.ambition === value
      })[0]
      if (typeof item !== "undefined") {
        item.addtoCart = !item.addtoCart
      }
    },
    getCartState(value) {
      // const item = this.$store.state.cart.cart.filter(obj => {
      const item = this.varCandidates.filter(obj => {
      return obj.ambition === value
      })[0]
      if (typeof item !== "undefined") {
        return item.addtoCart
      }
    }
  },
  mounted() {
    // if (localStorage.getItem('toggle') === 'true' && localStorage.getItem('toggle').length ===  this.$store.state.candidates.candidates.length) {
    if (localStorage.getItem('varCandidates')) {
          this.varCandidates = JSON.parse(localStorage.getItem('varCandidates'));
    } else {
      for(var i in this.$store.state.candidates.candidates) {
        var item = this.$store.state.candidates.candidates[i];
        this.varCandidates.push({
          "ambition" : item.ambition,
          "isOpen"  : false,
          "addtoCart": false,
          "carerix_id": item.carerix_id
      });
    }
    }
  },
  watch: {
    varCandidates: {
      handler() {
      localStorage.setItem('varCandidates', JSON.stringify(this.varCandidates));
      this.$store.dispatch('cart/getCart');
      // this.getCart();
      },
    deep: true
  }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../assets/css/shared.scss';
.bg-1{
  background: url("../assets/naniungo-slide-19.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height:500px;
  background-position: right 0px top 34px !important; 
}
.profiles{
  margin-left:10px;
  margin-right:10px;

.md-card-header {
    padding: 16px;
}

.md-card {
    margin: 10px;
    width:55vw;
    display: inline-block;
    vertical-align: top;
  }

@media (min-width: 300px) and (max-width: 1300px) {
  .md-card {
    width:50vw;
    }
}

.md-title{
  // margin-right:80px !important;
  h3{
    font-size:30px !important;
    margin-top:-2px;
    font-weight: 900;
  }
}
.md-subhead{
  // margin-right:80px !important;
  p{
    font-size:16px !important;
    color: $primary-font;
  }
}
.md-card-actions{
  margin-bottom:5px;
  margin-right:5px;
}
}

@media (min-width: 947px) {
  .blog{
    h1{
    font-size: 50px;
    line-height: 56px;
    font-weight:300;
  }
  p{
    font-size: 20px;
    line-height: 28px;
  }
}
}
@media (max-width: 1200px) {
  .blog{
    h1{
    font-size: 25px;
    line-height: 33px;
    font-weight:300;
  }
  p{
    font-size: 13px;
    line-height: 20px;
  }
  .blog-margin{
    padding-top:10px;
    padding-left:40px;
    padding-right:40px;
    padding-bottom:40px;
}
}
}
@media (max-width: 1600px) {
  .blog{
    h1{
    font-size: 30px;
    line-height: 36px;
    font-weight:300;
  }
  p{
    font-size: 15px;
    line-height: 20px;
  }
}
}

.blog{
  margin-left:10vw; 
  margin-right:10vw;  
}


</style>
